import { styled } from "@mui/styles";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Accordion, Box } from "@mui/material";

export const StyledAccordian = styled(Accordion)(({ theme }) => ({
    padding: '1.5rem 0 1.5rem 0',
    boxShadow: 'none !important',
    '& .MuiAccordionSummary-content p': {
        fontWeight: 700
    },
    '& .MuiAccordionDetails-root': {
        [theme.breakpoints.down('sm')]: {
            maxWidth: '300px'
        }
    },
    // '& .MuiCollapse-root': {
    //     overflow: 'auto'
    // }
}));

export const StyledDiv = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        padding: 0
    },
    padding: '4rem 0 0',
    textAlign: 'center',
    '& h4': {
        fontWeight: 700
    },
    '& .MuiTypography-subtitle': {
        fontFamily: 'Proxima Nova Rg',
        color: '#767676'
    }
}))

const useStyles = makeStyles((theme) =>
    createStyles({
        flexBox: {
            [theme.breakpoints.down('sm')]: {
                padding: '1rem'
            },
            margin: '0 auto',
            alignItems: 'center'
        },
        questionsDiv: {
            maxWidth: '70rem',
            '& h5': {
                fontWeight: 700
            },
            '& :last-child': {
                paddingBottom: 0,
            }
        }
    }),
);

export default useStyles;